const state = {
    paginationTypes : [],
    purchasesTypes: [],
    placesTypes: [],
    lineHeightsTypes: [],
    subscriptionStatusesTypes: [],
    sectorsTypes: [],
}

export default state